import React from "react";

const styles = {
  container: {
    fontFamily: "Arial, sans-serif",
    padding: "20px",
    maxWidth: "1000px",
    margin: "0 auto",
  },
  header: {
    backgroundColor: "#f44336",
    color: "white",
    padding: "10px 15px",
    fontSize: "20px",
    fontWeight: "bold",
    borderRadius: "4px",
    marginTop: "40px",
    display: "flex",
    justifyContent: "center",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "10px",
    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
  },
  th: {
    backgroundColor: "#f5f5f5",
    fontWeight: "bold",
    borderTop: "1px solid #ddd",
    borderBottom: "1px solid #ddd",
    padding: "8px",
    textAlign: "left",
  },
  td: {
    border: "1px solid #ddd",
    padding: "8px",
  },
};

const ModelViewProgramList = ({ tableContent }) => {
  return (
    <div style={styles?.container}>
      {Object.entries(tableContent).map(([qarku, programet]) => (
        <div key={qarku}>
          <div style={styles?.header}>{qarku}</div>
          <table style={styles?.table}>
            <thead>
              <tr>
                <th style={styles?.th}></th>
                <th style={styles?.th}>Programi</th>
                <th style={styles?.th}>Licenca</th>
                <th style={styles?.th}>Rrjeti numerik ku mbartet</th>
                <th style={styles?.th}>Mbulesa e sinjalit</th>
              </tr>
            </thead>
            <tbody>
              {programet.map((p, idx) => (
                <tr key={idx}>
                  <td style={styles?.td}>{idx + 1}</td>
                  <td style={styles?.td}>{p["Programi"]}</td>
                  <td style={styles?.td}>{p["Licensa"]}</td>
                  <td style={styles?.td}>{p["Rrjeti numerik ku mbartet"]}</td>
                  <td style={styles?.td}>{p["Mbulimi faktik me sinjal"]}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ))}
    </div>
  );
};

export default ModelViewProgramList;
